import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useState } from 'react'
import styled from 'styled-components'
import { ICON_TYPES } from '../constantes/iconos.ts'
import Titulo from './Titulo'

const Caja = ({ titulo, texto, navegar }) => {
    const [activo, setActivo] = useState(false)
    return (
        <Container estado={activo.toString()}>
            <Main>
                <Titulo color='#444' titulo={titulo} />
                <Boton estado={activo.toString()} onClick={() => setActivo(!activo)} >
                    <Icon icon={ICON_TYPES.TRIANGULO} style={{ fontSize: '36px' }} />
                </Boton>
            </Main>
            <p style={{ color: '#444' }}>{texto}</p>
        </Container>
    )
}

const Container = styled.div`
    margin-bottom: 20px;
    transition: 1s linear all;
    overflow: hidden;
    padding: 15px;
    width: max(45%, 400px);
    display: flex;
    flex-direction: column;
    background-color: white;
    height: ${props => props.estado === 'true' ? '100%' : '100px'};
    background-color: white;
    color: #444;
    border-radius: 20px;
`

const Main = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: 100px;
    margin-bottom: 20px;
    gap: 10px;
`
const Boton = styled.button`
    transition: 1s ease all;
    width: max-content;
    height: max-content;
    color: var(--primary);
    background-color: transparent;
    cursor: pointer;
    transform: rotate(${props => props.estado === 'true' ? '0' : '180deg'})
`

export default Caja